export default function Footer() {
  return (
    <footer className="border-t border-[#E2DCD0] bg-[#F2EFEB] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-full bg-[#E25A24] grid place-items-center text-white font-serif text-xl">स</div>
            <div className="font-serif text-xl text-[#13294B]">Swadeshi Bazaar</div>
          </div>
          <p className="mt-4 text-sm text-[#4A5568] leading-relaxed">
            A marketplace built to celebrate Indian artisans, homegrown brands, and locally-made goods.
          </p>
        </div>
        <div>
          <div className="label-caps mb-3">Shop</div>
          <ul className="space-y-2 text-sm text-[#4A5568]">
            <li>Handloom</li><li>Spices</li><li>Pottery</li><li>Ayurveda</li>
          </ul>
        </div>
        <div>
          <div className="label-caps mb-3">Vendors</div>
          <ul className="space-y-2 text-sm text-[#4A5568]">
            <li>Sell with us</li><li>Vendor guidelines</li><li>Payouts</li>
          </ul>
        </div>
        <div>
          <div className="label-caps mb-3">Support</div>
          <ul className="space-y-2 text-sm text-[#4A5568]">
            <li>Returns (7-day)</li><li>Track order</li><li>Contact us</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E2DCD0] py-6 text-center text-xs text-[#718096]">
        © 2026 Swadeshi Bazaar · Handmade with care in Bharat
      </div>
    </footer>
  );
}
